import { render } from "./TabooPatternsApp.vue?vue&type=template&id=6d5496ec"
import script from "./TabooPatternsApp.vue?vue&type=script&lang=js"
export * from "./TabooPatternsApp.vue?vue&type=script&lang=js"

import "./TabooPatternsApp.vue?vue&type=style&index=0&id=6d5496ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__